import Link from "next/link"
import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import Dropdown from "./dropdown"

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false)
  const router = useRouter()

  const isRouteActive = (route) => {
    return route === router.pathname ? "active" : ""
  }

  useEffect(() => {
    setMenuOpen(false)
  }, [router])

  const menuItems = (className, trigger) => {
    return (
      <>
        <Link href="/">
          <a
            onClick={() => setMenuOpen(!menuOpen)}
            className={`${className} ${isRouteActive("/")}`}
          >
            Home
          </a>
        </Link>
        <span
          onClick={() => setMenuOpen(!menuOpen)}
          className={`${className} ${isRouteActive("#servicos")} relative`}
        >
          <Dropdown btnName='Portfólio' trigger={trigger} />
        </span>
        <Link href="/#testemunhos">
          <a
            onClick={() => setMenuOpen(!menuOpen)}
            className={`${className} ${isRouteActive("/#testemunhos")}`}
          >
            Testemunhos
          </a>
        </Link>
        <Link href="/#contacto">
          <a
            onClick={() => setMenuOpen(!menuOpen)}
            className={`${className} ${isRouteActive("/#contacto")}`}
          >
            Contacto
          </a>
        </Link>
      </>
    )
  }

  return (
    <nav className="absolute container left-1/2 -translate-x-2/4 p-5 z-10 top-0">
      <div className="flex justify-between font-josefin-sans text-white">
        <Link href="/">
          <h1 className="uppercase text-2xl cursor-pointer">Sara Fontoura</h1>
        </Link>
        <div className="hidden md:flex">{menuItems("nav-link", "hover")}</div>
        <div className="md:hidden">
          <button
            aria-label="menu"
            className="focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg
              className={`${menuOpen ? "hidden" : "block"} h-6 w-6`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <svg
              className={`${menuOpen ? "block" : "hidden"} h-6 w-6`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        className={`${menuOpen ? "block" : "hidden"} md:hidden text-white`}
        id="mobile-menu"
      >
        <div className="flex flex-col mt-3 font-josefin-sans">
          {menuItems("dropdown-link", "click")}
        </div>
      </div>
    </nav>
  );
}
